export const palette = {
    almostBlack: "#010a13",
    gold1: "#f0e6d2",
    gold2: "#cdbe91",
    gold3: "#c8aa6e",
    gold4: "#c89b3c",
    gold5: "#785A2",
    gold6: "#463714",
    gold7: "#32281e",
    blue1: "#cdfafa",
    blue2: "#0ac8b9",
    blue3: "#3295c7",
    blue4: "#005a82",
    blue5: "#0a323c",
    blue6: "#0a1428",
    greyBlue: "#a3c7c7",
    frameGrey: "#1e282d",
    borderGrey: "#28282b",
    goldGrey: "#3c3732",
    grey1: "#a09b8c",
    grey2: "#3c3c41",
    grey3: "#1e2328",
    ip: "#1e825a",
    experience: "#643c5a",
    paladinBlue: "#0a96aa",
    paladinBlue2: "#0acbe6",
    mage: "#be1e37",
    mage2: "#ff2345",
    me: "#fabe0a",
};
//# sourceMappingURL=palette.js.map